import { getApi, getEncodedSearchString, postApi } from "../../common/actions/net.js";
import { getExistingProductImage, loadProductImage } from "../../kundeweb/actions/productImage.js";
import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";

import Logger from "../../common/util/Logger.js";
import { UPDATE_MULTI_EPIX_PRODUCT_LIST } from "./multiEpixSortiment.js";

import moment from "moment";
import { toLocaleFixed} from "../../common/util/localization.jsx";

export const SET_MULTI_CHAIN_SORTIMENT = "SET_MULTI_CHAIN_SORTIMENT";
export const ADD_MULTI_CHAIN_SORTIMENT = "ADD_MULTI_CHAIN_SORTIMENT";
export const SET_QUERY_PRODUCT_IMAGE_URL = "SET_QUERY_PRODUCT_IMAGE_URL";
export const MULTI_CHAIN_SORTIMENT_IS_LOADING = "MULTI_CHAIN_SORTIMENT_IS_LOADING";
export const MULTI_CHAIN_QUERY_DONE_LOADING = "MULTI_CHAIN_QUERY_DONE_LOADING";
export const MULTI_CHAIN_QUERY_FAILED_LOADING = "MULTI_CHAIN_QUERY_DONE_LOADING";
export const MULTI_CHAIN_QUERY_ALL_LOADED = "MULTI_CHAIN_QUERY_ALL_LOADED";
export const EDIT_MULTI_CHAIN_FILTER = "EDIT_MULTI_CHAIN_FILTER";
export const CLEAR_MULTI_CHAIN_SORTIMENT = "CLEAR_MULTI_CHAIN_SORTIMENT";
export const SET_MULTI_CHAIN_SORTIMENT_FILTER = "SET_MULTI_CHAIN_SORTIMENT_FILTER";

export const SET_MULTI_CHAIN_PRODUCT_DETAIL = "SET_MULTI_CHAIN_PRODUCT_DETAIL";
export const CLEAR_MULTI_CHAIN_PRODUCT_DETAIL = "CLEAR_MULTI_CHAIN_PRODUCT_DETAIL";
export const UPDATE_MULTI_CHAIN_PRODUCT_LIST = "UPDATE_MULTI_CHAIN_PRODUCT_LIST";
export const SET_INVOICE_GROUPS = "SET_INVOICE_GROUPS";
export const SET_QUERY_OPTION = "SET_QUERY_OPTION";

export const LOADING_NEW_CHAIN_PRODUCTS = "LOADING_NEW_CHAIN_PRODUCTS";
export const SET_NEW_CHAIN_PRODUCTS = "SET_NEW_CHAIN_PRODUCTS";

export const SET_MULTI_SELECT = "SET_MULTI_SELECT";
export const CLEAR_MULTI_SELECT = "CLEAR_MULTI_SELECT";

const setQueryProductImageUrl = (index, imageUrl) => ({
    type: SET_QUERY_PRODUCT_IMAGE_URL,
    index,
    imageUrl
});

const setMultiChainSortimentIsLoading = () => ({
    type: MULTI_CHAIN_SORTIMENT_IS_LOADING
});
const setMultiChainSortimentDoneLoading = () => ({
    type: MULTI_CHAIN_QUERY_DONE_LOADING
});
const setMultiChainSortimentFailedLoading = () => ({
    type: MULTI_CHAIN_QUERY_FAILED_LOADING
});

const setMultiChainSortimentAllLoaded = () => ({
    type: MULTI_CHAIN_QUERY_ALL_LOADED
});

const setNewChainProducts = (products) => ({
    type: SET_NEW_CHAIN_PRODUCTS,
    products
});

/**
 * Downloads more multi chain sortiment items
 * @param {object} multiChainSortiment
 * @param {object} productImage
 * @param {number} noOfProducts
 * @returns {func}
 */
export function loadMoreMultiChainSortiment(multiChainSortiment, productImage, noOfProducts = 50) {
    return async (dispatch, getState) => {
        try {
            //make sure there is something new to load
            if (multiChainSortiment.allResultsLoaded) {
                return;
            }

            const state = getState();

            //start collection new lines
            dispatch(setMultiChainSortimentIsLoading());

            const startIndex = multiChainSortiment.chainProducts.length;

            // Load in more products
            const { payload } = await dispatch(
                getApi("Chain/ProductsFreeTextQuery", {
                    chainType: state.authentication.chainType,
                    chainId: multiChainSortiment.chainFilter.chainId,
                    onlyAvailableForChain: true,
                    noOfProducts: noOfProducts,
                    startIndex: startIndex,
                    freeText: getEncodedSearchString(multiChainSortiment.chainFilter.searchString),
                    supplierId: multiChainSortiment.chainFilter.supplierId ? multiChainSortiment.chainFilter.supplierId : undefined,
                    productGroupId: multiChainSortiment.chainFilter.productGroupId ? multiChainSortiment.chainFilter.productGroupId : undefined,
                    InvoiceGroup:  multiChainSortiment.chainFilter.invoiceGroupId ? multiChainSortiment.chainFilter.invoiceGroupId : undefined,
                    ProductStatus: multiChainSortiment.chainFilter.productStatus >= 0 ? multiChainSortiment.chainFilter.productStatus : undefined,
                    onlyNews: false,
                })
            );

            // Check if all data has been loaded
            if (payload.products.length != noOfProducts) {
                dispatch(setMultiChainSortimentAllLoaded());
            }

            // Insert existing images
            for (let i = 0; i < payload.products.length; i++) {
                payload.products[i].imageUrl = getExistingProductImage(payload.products[i].productId);
            }
            // Convert to default layout
            const prdList = payload.products.map(prd => {
                return { product: prd };
            });

            // Store query results
            await dispatch({ type: ADD_MULTI_CHAIN_SORTIMENT, chainProducts: prdList });

            // Download all images not already inserted
            for (let index = 0; index < prdList.length; index++) {
                if (!prdList[index].product.imageUrl || prdList[index].product.imageUrl.length === 0) {
                    const callback = imageUrl => dispatch(setQueryProductImageUrl(startIndex + index, imageUrl));
                    dispatch(loadProductImage(productImage, prdList[index].product.productId, prdList[index].product.imageFileName, callback));
                }
            }

            dispatch(setMultiChainSortimentDoneLoading());
        } catch (error) {
            dispatch(setMultiChainSortimentFailedLoading());
            dispatch(pushSystemMessage(error && error.message || "Varesøk mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Changes the query filter
 * @param {object} change
 * @param {func}   callback // function will be called when the state has been updated
 * @returns {func}
 */
export function editMultiChainFilter(change, callback) {
    return async dispatch => {
        await dispatch({
            type: EDIT_MULTI_CHAIN_FILTER,
            change
        });

        try {
            dispatch(setMultiChainSortimentIsLoading());
            await callback();
        } catch (error) {
            Logger.error(error);
        } finally {
            dispatch(setMultiChainSortimentDoneLoading());
        }
    };
}

/**
 * Clears the single chain sortiment
 * @returns {func}
 */
export function clearMultiChainSortiment() {
    return async dispatch => {
        dispatch({
            type: CLEAR_MULTI_CHAIN_SORTIMENT
        });
    };
}

/**
 * Sets the single chain sortiment filter "OnlyAvailableForChain" flag
 * @param {object} change
 * @returns {func}
 */
export function setMultiChainSortimentFilter(change) {
    return async dispatch => {
        dispatch({
            type: SET_MULTI_CHAIN_SORTIMENT_FILTER,
            change
        });
    };
}

/**
 * Changes the query filter
 * @returns {func}
 */
export function prepareQueryOptions() {
    return async (dispatch, getState) => {
        const state = getState();
        const payload = await dispatch(getApi("Chain/FilterOptionsQuery",  {
            chainType: state.authentication.chainType}));
        dispatch({
            type: SET_QUERY_OPTION,
            productGroups: payload ? payload.payload.productGroups : null,
            productSuppliers: payload ? payload.payload.suppliers : null
        });
    };
}

/**
 * Gets product details for the given product id
 * @param {number[]} chainIds
 * @param {string} productId
 * @param {string} imageUrl
 * @returns {function.<string>}
 */
export function getMultiChainProductDetail(chainIds, productId, imageUrl) {
    return async dispatch => {
        try {
            // Call webApi to make Products details request
            const productDetails = {};
            for (const chainId of chainIds) {
                const { payload } = await dispatch(getApi("Chain/ProductsDetailQuery", { chainId, productId }));
                payload.imageUrl = imageUrl;
                productDetails[chainId] = payload;
            }

            dispatch({
                type: SET_MULTI_CHAIN_PRODUCT_DETAIL,
                productDetails
            });

            return productDetails;
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Å få vareinformasjonen mislykte", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Clears chain product detail modal
 * @returns {function.<string>}
 */
export function clearChainProductDetails() {
    return async dispatch => {
        try {
            dispatch({
                type: CLEAR_MULTI_CHAIN_PRODUCT_DETAIL
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Gets invoice groups
 * @returns {function.<string>}
 */
export function getInvoiceGroups() {
    return async dispatch => {
        try {
            // Call webApi to get a list of invoice groups
            const { payload: invoiceGroups } = await dispatch(getApi("Chain/InvoiceGroupsQuery"));

            dispatch({
                type: SET_INVOICE_GROUPS,
                invoiceGroups
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Innhenting av fakturagrupper mislyktes", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Commit product changes
 * @param {array} products
 * @returns {func}
 */
export function updateChainProducts(products) {
    return async (dispatch, getState) => {
        const state = getState();
        try {
            // dispatch({
            //     type: UPDATE_PRODUCTS,
            //     committing: true,
            // });

            const payload = await dispatch(
                postApi("Chain/UpdateChainProductsCommand", {
                    chainType: state.authentication.chainType,
                    productsToUpdate: products.map(p => {
                        return {
                            chainId: p.chainId,
                            productId: p.productId,
                            isAvailable: p.isAvailable,
                            inCatalogue: p.inCatalogue,
                            invoiceGroupId: p.invoiceGroupId,
                            sortimentCode: p.sortimentCode,
                            futureEndPrice: p.futureEndPrice,
                            futureEndPriceDate: p.futureEndPriceDate,
                            futureAdminCharge: p.futureAdminCharge,
                            futureAdminChargeDate: p.futureAdminChargeDate
                        };
                    })
                })
            );

            if (payload && payload.message === "OK") {
                dispatch(pushSystemMessage("Varer ble oppdatert!", messageType.message));
                // history.push("/dashboard");
                // dispatch({
                //     type: CLEAR_CLAIM,
                // });

                // Call reducer that updates the product in the list from free text search
                dispatch({ type: UPDATE_MULTI_CHAIN_PRODUCT_LIST, products });
                dispatch({ type: UPDATE_MULTI_EPIX_PRODUCT_LIST, products });
            } else {
                dispatch(pushSystemMessage(payload && payload.displayMessage || "Kan ikke oppdatere varer", messageType.error));
            }
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Kan ikke oppdatere varer", messageType.error));
            Logger.error(error);
        } finally {
            // dispatch({
            //     type: UPDATE_PRODUCTS,
            //     committing: false,
            // });
        }
    };
}

/**
 * Loads new products for active chain
 * @returns {func}
 */
export function getNewChainProducts() {
    return async (dispatch, getState) => {
        try {
            if (getState().productLists.newProductsLoading) {
                return;
            }
            dispatch({
                type: LOADING_NEW_CHAIN_PRODUCTS,
                loading: true
            });

            // Collect info regarding all the new products
            const { payload } = await dispatch(
                getApi("Chain/ProductsFreeTextQuery", {
                    chainType: getState().authentication.chainType,
                    onlyAvailableForChain: true,
                    noOfProducts: 1000,
                    startIndex: 0,
                    onlyNews: true,
                })
            );

            // Insert existing images
            for (let i = 0; i < payload.length; i++) {
                payload.products[i].imageUrl = getExistingProductImage(payload.products[i].productId);
            }

            // Convert to default layout
            const prdList = payload.products.map(prd => {
                return { product: prd };
            });

            await dispatch(setNewChainProducts(prdList));
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av nye produkter for kjeden mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: LOADING_NEW_CHAIN_PRODUCTS,
                loading: false
            });
        }
    };
}

export const LOADING_CHAINS = "LOADING_CHAINS";
export const LOADED_CHAINS = "LOADED_CHAINS";
export const LOADING_CHAINS_FAILED = "LOADING_CHAINS_FAILED";

/**
 * Loads the list of chains.
 * @returns {func}
 */
export function loadChains() {
    return async (dispatch,) => {
        dispatch({
            type: LOADING_CHAINS
        });

        try {
            const { payload } = await dispatch(getApi("Chain/ChainsQuery", {}));
        
            dispatch({
                type: LOADED_CHAINS,
                chains: Object.assign({}, ...payload.map(c => ({
                    [c.chainId]: c
                })))
            });
        } catch (_) {
            dispatch({
                type: LOADING_CHAINS_FAILED
            });
        }
    };
}

/**
 * Sets if the product is selected ot not
 * @param {object} change
 * @returns {function}
 */
export function editSelectedProduct(change) {
    return async dispatch => {
        try {
            dispatch({
                type: SET_MULTI_SELECT,
                change,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Clears all multi selected products
 * @returns {function}
 */
export function clearSelectedProducts() {
    return async dispatch => {
        try {
            dispatch({
                type: CLEAR_MULTI_SELECT,
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}

/**
 * Exports the contents to a CSV file
 * @param {object} multiChainSortiment
 * @returns {function}
 */
export function exportCsv(multiChainSortiment) {
    return async (dispatch, getState) => {
        try {
            


            const state = getState();

            // Load in more products
            const { payload }  = await dispatch(
                getApi("Chain/ProductsFreeTextQuery", {
                    chainType: state.authentication.chainType,
                    chainId: multiChainSortiment.chainFilter.chainId,
                    onlyAvailableForChain: true,
                    noOfProducts: 10000,
                    startIndex: 0,
                    freeText: getEncodedSearchString(multiChainSortiment.chainFilter.searchString),
                    supplierId: multiChainSortiment.chainFilter.supplierId ? multiChainSortiment.chainFilter.supplierId : undefined,
                    productGroupId: multiChainSortiment.chainFilter.productGroupId ? multiChainSortiment.chainFilter.productGroupId : undefined,
                    InvoiceGroup:  multiChainSortiment.chainFilter.invoiceGroupId ? multiChainSortiment.chainFilter.invoiceGroupId : undefined,
                    ProductStatus: multiChainSortiment.chainFilter.productStatus >= 0 ? multiChainSortiment.chainFilter.productStatus : undefined,
                    onlyNews: false,
                })
            );

            const rows =  [["Kjede", "Varetekst", "EPD", "Åpen", /*"I Katalog",*/ "Varestatus",                 
                "Gjeldende nettopris inkl. adm", "Gjeldende Nettopris pr f-pak", 
                "Fremtidig nettopris inkl. adm", "Fremtidig Nettopris pr f-pak", "Gjelder fra dato",
                "Gjeldende Adm gebyr", "Fremtidig Adm gebyr", "Gjelder fra dato",
                "Fakturagruppe", "Sortimentkode", "Antall f-pak i d-pak", "Endringsdato", 
                "Kolly varenr", "Leverandør navn", "Leverandør varenr", 
                "Gjeldende detaljistpris ex adm", "Fremtidig detaljistpris ex adm",  "Gjelder fra dato",
                "Gjeldende grunnlag for Adm/PDCC", "Fremtidig grunnlag for Adm/PDCC", "Gjelder fra dato",
                "Gjeldende pris inkl. avgifter ex Adm/PDCC", "Fremtidig pris inkl. avgifter ex Adm/PDCC", "Gjelder fra dato",
                "Gjeldende kampanjepris", "Fremtidig kampanjepris", "Gjelder fra dato",
                "Varegruppe", "Kalkylegruppe",
                "EAN F-pack", "EAN D-pak", "MVA", "Varetype", "Status", "Linket til vare", "Erstatter", "Holdbarhet (dager)", "Nettovekt (kg)", "Anbrekk",
                "Antall enheter i hel eske", "Pant pr D-pak / F-pack","Grunnpris", "Vekt F-pack (g)", "Bredde F-pack", "Høyde F-pack", "Dybde F-pack", "Felles",
                "Gjeldende utsalgspris", "Fremtidig utsalgspris", "Gjelder fra dato"]];
                
            for (const p of payload.products) {

                const lastChangedDate = !p.lastChangedDate ? null : moment(p.lastChangedDate).format("DD.MM.YYYY");
                const futureCustomerBasePriceDate = !p.futureCustomerBasePriceDate ? null : moment(p.futureCustomerBasePriceDate).format("DD.MM.YYYY");
                const futureEndPriceDate = !p.futureEndPriceDate ? null : moment(p.futureEndPriceDate).format("DD.MM.YYYY");
                const futureAdminChargeDate = !p.futureAdminChargeDate ? null : moment(p.futureAdminChargeDate).format("DD.MM.YYYY");

                rows.push([p.chainName, p.productName, p.epdNo, /*p.isAvailable ? "Ja" : "nei",*/ p.inCatalogue ? "Ja" : "nei", p.status,                    
                    toLocaleFixed(p.currentNetPrice, 2),  toLocaleFixed(p.currentNetPricePerSalesUnit, 3),  
                    toLocaleFixed(p.futureNetPrice, 3), toLocaleFixed(p.futureNetPricePerSalesUnit, 3), futureCustomerBasePriceDate,
                    toLocaleFixed(p.adminChargePercent, 2), toLocaleFixed(p.futureAdminCharge, 2), futureAdminChargeDate,
                    p.invoiceGroupName, p.catalogueCode, p.noOfSalesUnits, lastChangedDate,
                    p.productId, p.supplierName, p.supplierProductId, 
                    toLocaleFixed(p.currentCustomerBasePrice,2), toLocaleFixed(p.futureCustomerBasePrice,2), futureCustomerBasePriceDate,
                    toLocaleFixed(p.basePriceForAdminCharge,2), toLocaleFixed(p.futureBasePriceForAdminCharge,2), futureCustomerBasePriceDate, 
                    toLocaleFixed(p.customerBasePriceWithChargesExclAdminCharge,2),  toLocaleFixed(p.futureCustomerBasePriceWithChargesExclAdminCharge,2), futureCustomerBasePriceDate,
                    toLocaleFixed(p.currentCampaignPercent,2),  toLocaleFixed(p.futureCampaignPercent,2), p.futureCampaignPeriod,
                    p.category, p.calcGroup,
                    p.eanNoSalesUnit, p.eanNoWarehouseUnit, toLocaleFixed(p.vatRate,2), p.productStorageType, p.status, p.linkProductId, p.replacingProductIds, p.durabilityDays, toLocaleFixed(p.weight,2), p.useSalesUnit ? "Ja" : "Nei",
                    p.noOfUnitsInPackage, p.depositAmountWarehouseAndSalesUnit, toLocaleFixed(p.currentInPrice,2), toLocaleFixed(p.weightSalesUnit,3), toLocaleFixed(p.widthSalesUnit,3), 
                    toLocaleFixed(p.heightSalesUnit,3), toLocaleFixed(p.lengthSalesUnit,3), p.uniqueForChain ? "Ja" : "Nei",
                    toLocaleFixed(p.currentEndCusPrice, 2), toLocaleFixed(p.futureEndPrice, 2), futureEndPriceDate,
                ]);
            }

            var BOM = "\uFEFF"; 
            const csvContent =  `data:text/csv;charset=utf-8,${BOM}${rows.map(e => e.join(";")).join("\n")}`;

            var encodedUri = encodeURI(csvContent).replace(/#/g, "%23");
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "chain_sortiment.csv");
            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file named "chain_sortiment.csv".


        } catch (error) {
            Logger.error(error);
        }
    };
}
